import { QuickRatioValues, QuickRatioResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

export function calculateQuickRatio(values: QuickRatioValues, t?: ToolsTranslations['quickRatio']): QuickRatioResult {
  const { currentAssets, inventory, currentLiabilities } = values;

  if (currentAssets < 0) {
    return { ratio: null, percent: null, isValid: false, message: t?.invalid.currentAssets ?? 'Omsättningstillgångar måste vara 0 eller mer' };
  }
  if (inventory < 0) {
    return { ratio: null, percent: null, isValid: false, message: t?.invalid.inventory ?? 'Varulager måste vara 0 eller mer' };
  }
  if (currentLiabilities <= 0) {
    return { ratio: null, percent: null, isValid: false, message: t?.invalid.currentLiabilities ?? 'Kortfristiga skulder måste vara större än 0' };
  }

  const quickAssets = currentAssets - inventory;
  const ratio = quickAssets / currentLiabilities;
  const percent = ratio * 100;

  const ratioRounded = Math.round(ratio * 100) / 100; // 2 decimals
  const percentRounded = Math.round(percent); // no decimals requested

  if (!isFinite(ratioRounded) || !isFinite(percentRounded)) {
    return { ratio: null, percent: null, isValid: false, message: t?.invalid.generic ?? 'Ogiltiga värden' };
  }

  return { ratio: ratioRounded, percent: percentRounded, isValid: true };
}


